// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2r0-n","fullView":"styles_fullView__1oV8V"};